import { Helmet } from "react-helmet-async";

const BASE_URL = "https://impaladigitalpayment.com";
const DEFAULT_IMAGE = `${BASE_URL}/logo512.png`;

function SeoHead({ title, description, path, image }) {
  const fullTitle = title ? `${title} | Impala Digital Payments` : "Impala Digital Payments — Business Payment Management Platform";
  const url = `${BASE_URL}${path || ""}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}

export default SeoHead;
